export function hasShiftTimes(shift) {
  const valid = value => /^([01]\d|2[0-3]):[0-5]\d$/.test(value || "");
  return valid(shift?.start) && valid(shift?.end) && shift.start !== shift.end;
}

export function shiftHours(shift) {
  if (!hasShiftTimes(shift)) return 0;
  const minutesOf = value => { const [hours, minutes] = value.split(":").map(Number); return hours * 60 + minutes; };
  let minutes = minutesOf(shift.end) - minutesOf(shift.start);
  if (minutes < 0) minutes += 24 * 60;
  if (minutes > 6 * 60) minutes -= 30;
  return Math.max(0, minutes / 60);
}

// A saved period roster owns membership. Defaults only seed an unsaved roster.
export function periodRoster(saved, fallback) {
  return saved?.length ? saved : fallback;
}

// On-site hours remain payable; MOD presence never fills a front-desk slot.
export function frontDeskCoverageHours(shift) {
  return shift?.mod === true || ['unavailable', 'cross_center'].includes(shift?.shift_type) ? 0 : shiftHours(shift);
}
